import * as React from 'react';
import Helmet from 'react-helmet';
import { Grid, Paper, Typography, withStyles, WithStyles } from 'material-ui';

import { AppBarPadding, blueBorderValue, invertedText } from '../utils/styles';

interface BlogPostProps extends WithStyles<keyof typeof styles> {
  data: {
    site: {
      siteMetadata: {
        title: string;
      };
    };
    contentfulBlogPost: {
      title: string;
      originalCreatedAt: string | null;
      createdAt: string;
      body: {
        childMarkdownRemark: {
          html: string;
        };
      };
    };
  };
}

const styles = {
  container: {
    ...AppBarPadding,
  },
  invertedText: {
    ...invertedText,
  },
  post: {
    border: blueBorderValue,
    padding: '2rem',
    paddingTop: '1rem',
    marginTop: '2rem',
  },
};

export class BlogPost extends React.PureComponent<BlogPostProps> {
  render() {
    const { classes, data } = this.props;
    const post = data.contentfulBlogPost;

    return (
      <React.Fragment>
        <Helmet title={`${data.site.siteMetadata.title}: ${post.title}`} />
        <Grid container justify="center" className={classes.container}>
          <Grid item xs={11} sm={10}>
            <Typography variant="display1" className={classes.invertedText}>
              {post.title}
            </Typography>
            <Typography variant="subheading" className={classes.invertedText}>
              {post.originalCreatedAt || post.createdAt}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={10}>
            <Paper className={classes.post}>
              <Typography variant="body2" dangerouslySetInnerHTML={{ __html: post.body.childMarkdownRemark.html }} />
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(BlogPost);

export const pageQuery = graphql`
  query BlogPostByIds($id: String!) {
    site {
      siteMetadata {
        title
      }
    }
    contentfulBlogPost(id: { eq: $id }) {
      title
      originalCreatedAt(formatString: "dddd MMMM D, YYYY")
      createdAt(formatString: "dddd MMMM D, YYYY")
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/BlogPost.tsx